var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoVehicles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 2.25L1.25 20.75H4.5L23 2.25H19.75Z",
    fill: "#4E5968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0858 4.5H3.5C2.4 4.5 1.5 5.39 1.5 6.5V15.5H3.5C3.5 15.9638 3.60461 16.4026 3.79157 16.7942L5.2624 15.3234C5.34011 14.7746 5.77462 14.3401 6.32339 14.2624L7.78972 12.7961C7.4014 12.6068 6.96576 12.5 6.5 12.5C5.61 12.5 4.83 12.89 4.28 13.5H3.5V11.5H9.08579L11.0858 9.5H9.5V6.5H13.5V7.08579L16.0858 4.5ZM7.5 6.5H3.5V9.5H7.5V6.5Z",
    fill: "#4E5968"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91421 13.5L7.7376 15.6766C7.65989 16.2254 7.22538 16.6599 6.67661 16.7376L5.20578 18.2084C5.3025 18.2546 5.40209 18.2958 5.50423 18.3316L10.3358 13.5H9.91421Z",
    fill: "#4E5968"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3358 11.5H11.9142L15.5 7.91421V8.33578L12.3358 11.5Z",
    fill: "#4E5968"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1642 13.5H16.28C16.83 12.89 17.62 12.5 18.5 12.5C19.38 12.5 20.17 12.89 20.72 13.5H21.5V11.5H15.1642L17.1642 9.5H19.5L18.3321 8.33211L19.8321 6.83211L23.5 10.5V15.5H21.5C21.5 17.16 20.16 18.5 18.5 18.5C16.84 18.5 15.5 17.16 15.5 15.5H11.1642L13.1642 13.5ZM17.25 15.5C17.25 16.19 17.81 16.75 18.5 16.75C19.19 16.75 19.75 16.19 19.75 15.5C19.75 14.81 19.19 14.25 18.5 14.25C17.81 14.25 17.25 14.81 17.25 15.5Z",
    fill: "#4E5968"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2071 5.20711L18.4179 5.41789L16.9179 6.91789L16.7071 6.70711L18.2071 5.20711Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehicles);
export default __webpack_public_path__ + "static/media/NoVehicles.afc06b6c469ac48b8a1c9cd13116cc24.svg";
export { ForwardRef as ReactComponent };